import { Box } from "@mui/material";
import { TransForm } from "../../common/TransForm/Index";
import { PageTitle } from "../../common/PageTitle";
import Divider from '@mui/material/Divider';
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import { useCallback, useEffect, useState } from "react";
import { Typography } from "antd";
import ModalPopUp from "../../common/TransForm/ModalPopUp";
import { base_url } from "../../backendurl/url";
import Axios from "axios";
import { Config } from "../../../utils/commonFuctions/Token";
import { FirebaseImageUpload } from "../../common/FirebaseImageUpload";
import { S3ImageUpload } from "../../common/S3ImageUpload";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";
import { Notification } from "../../common/Notification";
import advBannerConfig from "../../common/jsons/formConfigs/advBannerConfig";
import { ClipLoader } from "react-spinners"; 

const placementOptions = [ 
  { id: "landing_page", name: "Landing Page Hero" },
  { id: "landing_page_mobile", name: "Landing Page Hero Mobile" },
  { id: "landing_rounds", name: "Landing Page Section 2" },
  { id: "rounds_page", name: "Rounds Page" },
  { id: "home", name: "Home Page" },
];

const textAlignment = [ 
  { id: "left", name: "Left" },
  { id: "center", name: "Center" },
  { id: "right", name: "Right" }
];

// Image size restrictions for validation - Updated to match advBannerConfig.js
const imageSizeRestrictions = {
  landing_page_mobile: { width: 375, height: 812, exactMatch: true }, // Fixed height from 812 to 375
  landing_page: { width: 1440, height: 580, exactMatch: true },
  landing_rounds: { width: 1440, height: 580, exactMatch: true },
  rounds_page: { width: 1240, height: 230, exactMatch: true },
  home: { minWidth: 1, maxWidth: 1240, height: 230, exactMatch: false }, // Flexible width, exact height
};

export const AdvBannersForm = ({ mode }) => {
  const [popup, setPopup] = useState(false);
  const [placements, setPlacementsData] = useState(placementOptions);
  const [systempopup, setSystemPopup] = useState('');
  const [notification, setnotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedPlacement, setSelectedPlacement] = useState('');
  const [formInputs, setFormInputs] = useState([]);
  const [imageValidationError, setImageValidationError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const [advBannerData, setAdvBannerData] = useState({});
  const [selectedAdvBannerData, setSelectedAdvBannerData] = useState({});
  const { id } = useParams("id");

  // Updated custom image validation function to match advBannerConfig.js logic
  const validateImageSize = (file, placement) => {
    return new Promise((resolve, reject) => {
      
      if (!file || !placement) {
        resolve(true);
        return;
      }

      const restrictions = imageSizeRestrictions[placement];
      
      if (!restrictions) {
        resolve(true);
        return;
      }

      const img = new Image();
      img.onload = function() {
        const { width, height } = this;

        if (placement === 'home') {
          
          if (width > restrictions.maxWidth) {
            reject(`Image width must be ${restrictions.maxWidth}px or less. Current width: ${width}px`);
          } else if (height !== restrictions.height) {
            reject(`Image height must be exactly ${restrictions.height}px. Current height: ${height}px`);
          } else {
            resolve(true);
          }
        } else {
          // For other placements: exact width and height match
          const { width: requiredWidth, height: requiredHeight } = restrictions;
          
          if (width !== requiredWidth || height !== requiredHeight) {
            reject(`Image size must be exactly ${requiredWidth}x${requiredHeight}px. Current size: ${width}x${height}px`);
          } else {
            resolve(true);
          }
        }
      };

      img.onerror = function() {
        reject('Invalid image file');
      };

      // Create URL for the image
      if (file instanceof File) {
        img.src = URL.createObjectURL(file);
      } else {
        reject('Invalid file type');
      }
    });
  };

  // Generate form inputs based on selected placement
  const generateFormInputs = useCallback(() => {
    const inputs = advBannerConfig({
      placements: placements,
      textAlignment: textAlignment,
      mode: mode,
      selectedPlacement: selectedPlacement,
      placement: selectedAdvBannerData.placement,
    });
    setFormInputs(inputs);
  }, [selectedPlacement, selectedAdvBannerData.placement, placements, mode]);

  // Generate form inputs when dependencies change
  useEffect(() => {
    generateFormInputs();
  }, [generateFormInputs]);

  // const onSubmit = async (data) => {
  //   // Reset image validation error
  //   setImageValidationError('');

  //   // Validate image size before proceeding
  //   if (data?.image && typeof data.image === 'object' && data.image.name) {
  //     const currentPlacement = data.placement || selectedPlacement;
      
  //     try {
  //       await validateImageSize(data.image, currentPlacement);
  //     } catch (error) {
  //       setImageValidationError(error);
  //       setErrorMessage(error);
  //       setnotification(true);
  //       return; // Stop form submission
  //     }
  //   }

  //   // Handle image upload for both new and edit modes
  //   if (data?.image && typeof data.image === 'object' && data.image.name) {
  //     try {
  //       if (base_url == process.env.REACT_APP_AWS_PROD) {
  //         const imageUrl = await S3ImageUpload(data?.image);
  //         data.image = imageUrl.location;
  //       } else {
  //         const imageUrl = await FirebaseImageUpload(data?.image);
  //         data.image = imageUrl.split('&')[0];
  //       }
  //     } catch (error) {
  //       console.error('Image upload failed:', error);
  //       setErrorMessage('Failed to upload image');
  //       setnotification(true);
  //       return;
  //     }
  //   }
    
  //   setAdvBannerData(data);
  //   setSystemPopup(`Are you sure to ${mode === "edit" ? "edit" : "create"} the new Adv Banner?`);
  //   setPopup(true);
  // };

  // Handle form data changes
  
  const onSubmit = async (data) => {
     setIsLoading(true); 
  setImageValidationError('');

  const currentPlacement = data.placement || selectedPlacement;

 
  if (!data?.image) {
    const errorMsg = 'Image is required. Please upload an image.';
    setImageValidationError(errorMsg);
    setErrorMessage(errorMsg);
    setnotification(true);
    setIsLoading(false); 
    return;
  }

  
  if (typeof data.image === 'object' && data.image.name) {
    try {
      await validateImageSize(data.image, currentPlacement);
    } catch (error) {
      setImageValidationError(error);
      setErrorMessage(error);
      setnotification(true);
      setIsLoading(false);
      return;
    }

    
    try {
      if (base_url === process.env.REACT_APP_AWS_PROD) {
        const imageUrl = await S3ImageUpload(data.image);
        data.image = imageUrl.location;
      } else {
        const imageUrl = await FirebaseImageUpload(data.image);
        data.image = imageUrl.split('&')[0];
      }
    } catch (error) {
      console.error('Image upload failed:', error);
      setErrorMessage('Failed to upload image');
      setnotification(true);
      setIsLoading(false);
      return;
    }
  }

  setAdvBannerData(data);
  setSystemPopup(`Are you sure to ${mode === "edit" ? "edit" : "create"} the Adv Banner?`);
  setPopup(true);
  setIsLoading(false);
};


  const handleFormDataChange = (formData, fieldName, value) => {
    if (fieldName === 'placement') {
      setSelectedPlacement(value);
      setSelectedAdvBannerData(prev => ({
        ...prev,
        placement: value
      }));
      // Clear image validation error when placement changes
      setImageValidationError('');
    }
    
    // Handle image field changes
    if (fieldName === 'image') {
      const currentPlacement = formData.placement || selectedPlacement;
      
      if (value && typeof value === 'object' && value.name && currentPlacement) {
        // Validate image size when image is selected
        validateImageSize(value, currentPlacement)
          .then(() => {
            setImageValidationError('');
          })
          .catch((error) => {
            setImageValidationError(error);
            setErrorMessage(error);
            setnotification(true);
          });
      }
    }
  };

  
  const getSelectedAdvBanner = useCallback(async () => {
    if (_.isEmpty(selectedAdvBannerData) && id) {
      const { data } = await Axios.get(`${base_url}/api/accounts/advbanners/${id}/`);
      
      if (data) {
        setAdvBannerData(data);
        setSelectedAdvBannerData(data);
        setSelectedPlacement(data.placement);
      }
    }
  }, [selectedAdvBannerData, id]);

  useEffect(() => {
    getSelectedAdvBanner();
  }, [getSelectedAdvBanner, id]);

  const launchBanner = (data) => {
    data.enabled = true;
    onSubmit(data);
  };

  const saveAdvBanner = async () => {
    try {
      if (mode === "edit") {
        const response = await Axios.put(`${base_url}/api/accounts/advbanners/${id}/`, advBannerData, Config);
        setPopup(false);
        navigate('/configurations/advbanners');
      } else if (mode === "new") {
        const response = await Axios.post(`${base_url}/api/accounts/advbanners/create/`, advBannerData, Config);
        setPopup(false);
        navigate('/configurations/advbanners');
      }
    } catch(error) {
      RefreshToken(error, setErrorMessage, setnotification);
    }
  };

  // Helper function to get image requirement text
  const getImageRequirementText = (placement) => {
    if (!placement) return '';
    
    const restrictions = imageSizeRestrictions[placement];
    if (!restrictions) return '';
    
    if (placement === 'home') {
      return `Width: up to ${restrictions.maxWidth}px, Height: exactly ${restrictions.height}px`;
    } else {
      return `Width: exactly ${restrictions.width}px, Height: exactly ${restrictions.height}px`;
    }
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {/* Loading Overlay */}
      {isLoading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <ClipLoader color="#3498db" loading={true} size={50} />
        </Box>
      )}

      <Box sx={{ px: 6, py: 3 }} alignContent="center">
        <PageTitle pageTitle={'Configure New Banner'} />
        <Typography>Enter the data below to configure a new banner</Typography>
        
        {/* Display current image size requirements */}
        {/* {selectedPlacement && imageSizeRestrictions[selectedPlacement] && (
          <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
            <Typography style={{ fontSize: '14px', color: '#666' }}>
              <strong>Image Requirements for {placementOptions.find(p => p.id === selectedPlacement)?.name}:</strong>
              <br />
              {getImageRequirementText(selectedPlacement)}
            </Typography>
          </Box>
        )} */}

        {/* Display image validation error */}
        {imageValidationError && (
          <Box sx={{ mt: 2, p: 2, bgcolor: '#ffebee', borderRadius: 1, border: '1px solid #ffcdd2' }}>
            <Typography style={{ fontSize: '14px', color: '#c62828' }}>
              <strong>Image Validation Error:</strong>
              <br />
              {imageValidationError}
            </Typography>
          </Box>
        )}
      </Box>
      
      <Divider sx={{ mb: 2, height: 4 }} />

      <TransForm
        submitAction={onSubmit}
        btnClick={launchBanner}
        data={selectedAdvBannerData}
        mode={mode}
        passFormData={handleFormDataChange}
        formInputs={formInputs}
      />
      
      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={'Confirm the action ?'}
        subTitle={systempopup}
        onClick={saveAdvBanner}
        save={'Yes'}
        cancel={'Exit'}
      />
      
      <Notification 
        message={errorMessage} 
        setopen={setnotification} 
        type={'error'} 
        show={notification} 
      />
    </Box>
  );
};